if (!window.customElements.get('language-dropdown')) {
  class LanguageDropdown extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.onDocumentClick = (event) => {
        if (!this.contains(event.target)) this.close();
      };
      this.onKeyup = (event) => {
        if (event.key === 'Escape') this.close(true);
      };

      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keyup', this.onKeyup);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      this.removeEventListener('keyup', this.onKeyup);
    }

    close(focusToggle = false) {
      if (!this.details?.open) return;

      this.details.open = false;
      if (focusToggle) this.details.querySelector('summary')?.focus();
    }
  }

  window.customElements.define('language-dropdown', LanguageDropdown);
}
